"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var colors = _interopRequireWildcard(require("@material-ui/core/colors"));
var _core = require("@material-ui/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const theme = (0, _core.createTheme)({
  colors,
  palette: {
    primary: {
      main: '#222'
    },
    background: {
      default: 'transparent'
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true
    },
    MuiButton: {
      disableElevation: true
    },
    MuiInput: {
      disableUnderline: true
    },
    MuiInputLabel: {
      shrink: true
    }
  },
  typography: {
    fontSize: 16
  }
});
theme.overrides = {
  MuiInput: {
    input: {
      border: '1px solid #d2d2d2',
      background: theme.colors.common.white,
      padding: `${theme.spacing(1)}px !important`
    }
  },
  MuiChip: {
    colorPrimary: {
      fontWeight: 700,
      color: '#FFF',
      backgroundColor: '#ED7D31'
    }
  }
};
var _default = exports.default = theme;